import axios from "axios";

let baseURL= process.env.REACT_APP_BASE_URL;

const instance = axios.create({
  baseURL: baseURL,
  timeout: 16000,
});

instance.defaults.headers.common["Content-Type"] = "application/json";

export default instance;
